import React from 'react'

const Error = () => {
    return (
        <>
            thi sis error page
        </>
    )
}

export default Error;
